import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { createContract, getExpenseConfig } from '../../api/constlink';
import { RootState } from '../../modules';
import {
  Contract,
  contractType1Enum,
  ContractMatchParams,
  contractStatusEnum,
} from '../../modules/contracts';
import {
  getPrimeContractFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
import PCCreateUpdateComponent from '../../components/contracts/PCCreateUpdateComponent';

function PrimeContractCreateContainer({
  history,
  match,
}: RouteComponentProps<ContractMatchParams>) {
  const { enterpriseId, projectId } = match.params;
  const currentProject = useSelector(
    (state: RootState) => state.projects.project.data,
  );

  const [uploadProps, setUploadProps] = useState<any>();
  const [expenseConfig, setExpenseConfig] = useState<any>();

  useEffect(() => {
    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getPrimeContractFileAPIPath(enterpriseId, projectId),
        ),
      );
      setExpenseConfig(await getExpenseConfig({ enterpriseId }));
    })();
  }, [enterpriseId, projectId]);

  const onFinish = async (contract: Contract) => {
    const contractObj: Contract = {
      ...contract,
      projectId,
      type1: contractType1Enum.PRIME_CONTRACT,
      status: contractStatusEnum.APPROVED,
      startDate: moment(contract.startDate).format('YYYY-MM-DD'),
      endDate: moment(contract.endDate).format('YYYY-MM-DD'),
    };

    if (contractObj.actualEndDate !== null)
      contractObj.actualEndDate = moment(contract.actualEndDate).format(
        'YYYY-MM-DD',
      );

    if (contractObj.contractDate !== null)
      contractObj.contractDate = moment(contract.contractDate).format(
        'YYYY-MM-DD',
      );

    if (contractObj.attachedFiles) {
      for (const _file of contractObj.attachedFiles) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    await createContract({
      enterpriseId,
      projectId,
      contractType1: contractType1Enum.PRIME_CONTRACT,
      contract: contractObj,
    });

    history.goBack();
  };

  const onCancel = () => {
    history.goBack();
  };

  return (
    <>
      {uploadProps && currentProject && expenseConfig && (
        <PCCreateUpdateComponent
          onFinish={onFinish}
          onCancel={onCancel}
          uploadProps={uploadProps}
          currentProject={currentProject}
          gongjongs={expenseConfig.gongjong}
        ></PCCreateUpdateComponent>
      )}
    </>
  );
}

export default PrimeContractCreateContainer;
